import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonProps } from '@node-space/storybook-components/dist/Button'
import {
  Modal,
  ModalActions,
  ModalBody,
  ModalNavBar,
} from '@node-space/storybook-components/dist/Modal'
import { AccountContactTranslation } from 'components/accountContact/accountContactV2/constants'
import { Description } from 'components/Text'
import { IdVerificationLink } from './IdVerificationLink'

export type AccountRepPerson = {
  fullName: string
  idVerificationLink: string
}

export type IdVerificationMessageMessageAccountRepProps = {
  person?: AccountRepPerson
  isLoading: boolean
  onBack: () => void
  onContinue: () => void
}

export const IdVerificationMessageAccountRep = ({
  person,
  isLoading,
  onBack,
  onContinue,
}: IdVerificationMessageMessageAccountRepProps) => {
  const { t } = useTranslation()

  const message = {
    title: t(`accountContact.createIdVerificationLink.title.myself`),
    requirements: t(
      `accountContact.createIdVerificationLink.requirements.${AccountContactTranslation.ACCOUNT_REPRESENTATIVE}`
    ),
    instructions: t('accountContact.createIdVerificationLink.instructions.myself'),
    closingLine: t('accountContact.createIdVerificationLink.appointAnother'),
  }

  if (!!person) {
    message.title = t('accountContact.createIdVerificationLink.title.anotherPerson', {
      contactFullName: person?.fullName,
    })
    message.instructions = t('accountContact.createIdVerificationLink.instructions.anotherPerson')
    message.closingLine = t('accountContact.createIdVerificationLink.convenientTime')
  }

  const actions: ButtonProps[] = [
    {
      loading: isLoading,
      children: t('continue'),
      onClick: onContinue,
    },
  ]

  return (
    <Modal visible closeModal={onBack}>
      <ModalNavBar title={message?.title} onBack={onBack} />
      <ModalBody spaceChildren={24}>
        <Description>{`${message?.requirements} ${message?.instructions}`}</Description>
        <Description>{message?.closingLine}</Description>
        {!!person && <IdVerificationLink url={person?.idVerificationLink} />}
      </ModalBody>
      <ModalActions actions={actions} />
    </Modal>
  )
}
